import { merge } from '../../helper';
import isEmptyObject from '../../general/isEmpty/isEmptyObject';
import prependChild from '../../general/prepend/prependChild';
import setAttr from '../../general/attr/setAttr';

import * as exInput from '../input';
import * as exElement from '../../utils/element';
import * as exEvent from '../../utils/event';

// ----------------------------------------------------------------------------

function create(config: Record<string, any> = {}): Record<string, any> {
    const defConfig: Record<string, any> = {};

    merge(defConfig, config);

    const build: Record<string, any> = {
        elements: {},
    };

    const input = exInput.create({
        merge: {
            ...defConfig,
            event: null,
        },
        type: 'range',
        class: {
            new: 'form-range',
        },
    });
    build.element = input.element;
    build.elements.element = input.element;

    settings(build, defConfig);
    events(build, defConfig);
    methods(build, defConfig);
    layouts(build, defConfig);

    return build;
}

function settings(build: Record<string, any>, config: Record<string, any> = {}): void {
    const elements = build.elements;

    if (config.value != null) {
        setAttr(elements.element, 'value', config.value);
        elements.element.value = config.value;
    }
}

function events(build: Record<string, any>, config: Record<string, any> = {}): void {
    const elements = build.elements;

    elements.element.addEventListener('input', function (this: HTMLInputElement): any {
        this.setAttribute('value', this.value);
    });

    elements.element.addEventListener('change', function (this: HTMLInputElement): any {
        this.setAttribute('value', this.value);
    });

    if (config.event != null) {
        exEvent.create(elements.element, config.event);
    }
}

function methods(build: Record<string, any>, config: Record<string, any> = {}): void {
    const elements = build.elements;

    const fnGetValue = function (): any {
        return elements.element.value;
    };
    build.getValue = fnGetValue;

    const fnSetValue = function (value): any {
        elements.element.value = value;
    };
    build.setValue = fnSetValue;
}

function layouts(build: Record<string, any>, config: Record<string, any> = {}): void {
    const elements = build.elements;

    const fnFirst = function (): any {
        if (elements.input) {
            return;
        }

        elements.input = elements.element;

        const elRange = exElement.create({
            merge: config.range,
            class: {
                new: 'range',
            },
        });
        build.element = elRange;
        elements.element = elRange;

        elements.element.appendChild(elements.input);
    };

    if (!isEmptyObject(config.label)) {
        fnFirst();

        const elLabel = exElement.create({
            merge: config.label,
            tag: 'label',
        });
        prependChild(elements.element, elLabel);
        elements.label = elLabel;
    }

    if (config.result === true || !isEmptyObject(config.result)) {
        fnFirst();

        const elResult = exElement.create({
            merge: config.result,
            tag: 'label',
            class: {
                new: 'float-end',
            },
            html: elements.input.value || 0,
        });
        prependChild(elements.element, elResult);
        elements.result = elResult;

        elements.input.addEventListener('input', function (this: HTMLInputElement): any {
            elResult.textContent = this.value;
        });

        elements.input.addEventListener('change', function (this: HTMLInputElement): any {
            elResult.textContent = this.value;
        });
    }
}

// ----------------------------------------------------------------------------

export { create };
